export default __webpack_public_path__ + "static/media/noReviewsFound.a2828444.png";